export function isEmpty(object: Object) {
  for (let _ in object) return false;

  return true;
}
